import en from './en';
import de from './de';

export default { en: en, de: de };
